module.exports = __webpack_public_path__ + "img/bg_festa10.d87f5902.jpg";